module.exports = __webpack_public_path__ + "static/media/Statua_048.0e583d43.jpg";